<template>
    <div class="animated fadeIn is-background-dark1">
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-white">
                            {{ $t('poc:poc.platform_title_up') }}
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                    <div class="column content" style="flex: inherit">
                        <iran-network class="iran-network" v-if="!isMobile()"></iran-network>
                        <iran-network class="iran-network mobile-screen" v-else></iran-network>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size- small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('poc:poc.platform_description') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container padding-top-1x uptin-text-center">
                        <router-link :to="'poc-network-description'" class="uptin-text-center uptin-text-center text-yellow" active-class="is-active is-active--advertiser">
                            {{ $t('poc:poc.platform_more') }}
                            <i v-bind:class = "isPersian(currentLocale)?'fas fa-angle-left':'fas fa-angle-right'" style="color: #ffbb00;"></i>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
    .iran-network {
        max-width: 500px;
        min-width: 500px;
        margin: 2%;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }
</style>

<script>
    import IranNetwork from "./components/network";

    export default {
        components: {
            IranNetwork
        },
        name: 'world-coverage',
        data() {
            return {
                currentLocale: this.$i18n.i18next.language || window.localStorage.i18nextLng
            };
        },
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
            isPersian(locale) {
                return locale.toLowerCase() === 'fa' || locale.toLowerCase() === 'ar';
            }
        }
    }
</script>
